import { computed, defineComponent, inject, onMounted } from 'vue';

import { StudentField } from '@studyportals/studentdomain';
import { IStore } from "@/interfaces/state.interface";

export default defineComponent({
	setup: () => {
		const store = inject('store') as IStore;
		const userName = computed((): string => {
			return store.getters.userName();
		});
		const topThreeLetters = computed((): string => {
			return store.getters.topThreeLetters();
		});

		const storeUserName = async (): Promise<void> => {
			if (!window.AnonymousStudent) {
				return;
			}
			
			const response = await window.AnonymousStudent.getStudentData([StudentField.NAME]);
			if (!response || !response.name) {
				return;
			}

			store.mutations.setUserName(response.name);
		};

		onMounted(storeUserName);

		return { userName, topThreeLetters };
	}
});
